import React from "react";
import { Button, Card, Col, Container, Form, Row, Tab } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import '../pegBoardTab/pegBoardTab.css';
import { PlusIcon, TrashIcon } from "@primer/octicons-react";
import PegBoardSettingCard from "./pegBoardSettingCard";

class PegBoardTab extends React.Component {

    constructor(props) {
        super(props)
        this._isMounted = false;
    }

    
    render() {
        
        return(
            <div style={{
                height: (
                    this.props.simType === "AUI"
                        ? this.props.catDivHeight
                        : this.props.catDivHeight + 250
                ),
                overflow: 'auto'
            }}>
            {this.props.pegList?.length === 0 && (
                <div className="v2-tab-content-view">
                        <Button onClick={() => this.props.handleAddPeg()} size="sm" className="v2-new-peg-btn w-100">{this.props.t("NEW")} <PlusIcon size={15}/></Button>
                </div>
            )}
            {this.props.pegList.length > 0 && (
                <div className="v2-tab-content-view">
                    <div className="peg-setting-box">
                    {this.props.pegList?.map((peg, index) => (
                        <PegBoardSettingCard key={index} peg={peg} isRTL={this.props.isRTL} t={this.props.t} handleAddPegHoles={this.props.handleAddPegHoles} handleDeletePeg={this.props.handleDeletePeg} handleEditPegHoles={this.props.handleEditPegHoles} handleUpdatePegHoles={this.props.handleUpdatePegHoles} isRectDrawingCompleted={this.props.isRectDrawingCompleted}/>
                    ))}
                    {this.props.pegList?.length > 0 && (
                        <Button disabled={!this.props.enableNextPegBoardSetting} onClick={() => this.props.handleAddPeg()} size="sm" className="v2-new-peg-btn w-100">{this.props.t("NEW")} <PlusIcon size={15}/></Button>
                    )}
                    </div>
                </div>
            )}
            </div>
        );
    }
}
export default withTranslation()(withRouter(connect(null)(PegBoardTab)))

    